import Vue from 'vue';
// initial state
const state = {
  destination: {},
  status: null,
  affectableForCurrentObject: [],
};

const mutations = {
  setDestinationRoles(currentState, destinationRoles) {
    Vue.set(currentState, 'destination', destinationRoles);
  },
  setAffectableForCurrentObject(currentState, roles) {
    Vue.set(currentState, 'affectableForCurrentObject', roles);
  },
};

export { mutations, state };
